import React from 'react';
import styles from './FormGroup.module.css';

function FormGroup(props: { children: React.ReactNode }) {
  return <div className={styles.root}>{props.children}</div>;
}

export default FormGroup;
